import { Form as AntdForm, type FormProps as AntdFormProps } from 'antd'
import type React from 'react'
import styled from 'styled-components'

type FormProps<T = any> = AntdFormProps & {
  children?: React.ReactNode
  customProp?: T
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const Form = <T = any>(props: FormProps<T>) => <StyledForm {...props} />

const StyledForm = styled(AntdForm)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
